import INavBar from "@src/component/INavBar";
import VerticalSpace from "@src/component/VerticalSpace";
import { replaceTo } from "@src/route";
import CommonService from "@src/service/commonService";
import { getUrlParams, isEmpty } from "@src/util";
import { Button, Picker, Radio, Space, Toast } from "antd-mobile";
import { DownFill } from "antd-mobile-icons";
import { Flex } from "antd-mobile-v2";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import "./index.scss";

interface DetailProps {
  registerprovince?: string;
  registercity?: string;
  firstpaidpercent?: number;

  [key: string]: any;
}

function PlanDetailEdit(props: any) {
  const [stageVisible, setStageVisible] = useState(false);
  const [firstpaidpercentVisible, setFirstpaidpercentVisible] = useState(false);
  const [ifcontainsecurityservice, setIfcontainsecurityservice] =
    useState(true);
  const {
    location: { search },
  } = props;
  const params = getUrlParams(search);
  const defaultDetail = {
    loaninginfoid: params.id,
    brandname:
      params.source === "cfmoto"
        ? "春风"
        : params.source === "zsmoto"
        ? "赛科龙"
        : params.source === "zeeho"
        ? "ZeehoApp"
        : params.source === "ktm"
        ? "KTM"
        : "",
    vehiclename: "",
    caramount: params.price,
    rate: parseFloat(params.rate),
    earnestmoneypercent: parseFloat(params.earnestmoneypercent),
    firstpaidpercent: parseFloat(params.firstpaidpercent),
    stage: 6,
    commissionrate: "",
    containtax: 0,
    containsecurityservice: 0,
    purchasepersonalaccidentinsurance: 0,
    containrideaccidentservice: 1,
    mortgageserviceamount: 0,
    paidamount: "0",
  };
  const [detail, setDetail] = useState<DetailProps>(defaultDetail);
  const [cfKcc, setCFcc] = useState<boolean>(false);
  const isEdit = useRef(false);
  useEffect(() => {
    CommonService.getConfig().then((res: any) => {
      if (!detail.commissionrate) {
        const source = params.source;
        const commRate = JSON.parse(res)[source].commissionRate;
        const lowestRate =
          params.source === "cfmoto"
            ? params.experiment === "1"
              ? JSON.parse(res).cfmoto.experiment
              : commRate
            : commRate;
        setDetail((val) => ({
          ...val,
          commissionrate: lowestRate,
        }));
      }
      CommonService.getPlanDetail({ loaningInfoId: params.id }).then(
        (res: any) => {
          res.stage = params.stage ? params.stage : 6;
          if (params.source === "zeeho" && !res.commissionrate) {
            res.commissionrate = 0.03;
          }
          setDetail((val) => ({
            ...val,
            containsecurityservice: res.containsecurityservice,
          }));
          // if (
          //   (params.source === "zeeho" ||
          //     params.source === "ktm" ||
          //     params.source === "cfmoto") &&
          //   res.cfKcc
          // ) {
          //   setIfcontainsecurityservice(false);
          // }

          if (res) {
            if (res.cfKcc) {
              res.stage = 12;
              if (params.source === "ktm") {
                res.stage = 18;
              }
              res.commissionrate = 0;
              setCFcc(true);
            }
            const brandname =
              params.source === "cfmoto"
                ? "春风"
                : params.source === "zsmoto"
                ? "赛科龙"
                : params.source === "zeeho"
                ? "ZeehoApp"
                : params.source === "ktm"
                ? "KTM"
                : res.brandname;
            const tem: any = {};
            // 手续费率
            if (params.source === "cfmoto") {
              res.commissionrate = res.cfKcc ? 0 : 0.03;
            } else {
              res.commissionrate = 0.03;
            }
            // 抵押代办费 全渠道置为 0
            if (!(params.source === "cfmoto" && res.cfKcc)) {
              res.mortgageserviceamount = 0;
            } else {
              res.mortgageserviceamount = res.mortgageserviceamount || 300;
              res.containtax = 0;
            }
            for (const k in res) {
              if (!isEmpty(res[k])) {
                tem[k] = res[k];
              }
            }

            setDetail({ ...detail, ...tem, brandname });
          }
        }
      );
    });
  }, []);

  const changeDetail = (newval: any) => {
    const detailN = { ...detail, ...newval };
    if (params.source == "zsmoto" && cfKcc && !isEmpty(newval.caramount)) {
      // 订单车型为宗申贴息车时，租赁期数：车价3万以下，最高24期；车价3万以上，最高36期；且只有12期、18期、24期、36期
      if (detailN.caramount < 30000 && detailN.stage < 12) {
        detailN.stage = 12;
      }
    }
    if (detailN.caramount < 30000 && detailN.stage >= 36) {
      detailN.stage = 24;
    }
    if (detailN.containtax > 0) {
      detailN.taxamount = Number(((detailN.caramount || 0) / 11.3).toFixed(0));
    } else {
      detailN.taxamount = 0;
    }
    setDetail(detailN);
  };

  // 期数选择
  const stageSelect = (val: any) => {
    changeDetail({
      stage: val[0],
    });
  };
  // 计算
  const caleResult = () => {
    if (
      !Object.keys(defaultDetail).every((item) => {
        console.log("item", item);
        return !isEmpty(detail[item]);
      })
    ) {
      Toast.show("请填写完整表单");
      return;
    }
    const caleParams: any = {
      ...detail,
    };
    if (detail.productat) {
      caleParams.productat = new Date(
        moment(detail.productat).format("YYYY/MM/DD HH:mm:ss")
      );
    }
    if (detail.firstregisterat) {
      caleParams.firstregisterat = new Date(
        moment(detail.firstregisterat).format("YYYY/MM/DD HH:mm:ss")
      );
    }
    CommonService.planCale(caleParams).then((res: any) => {
      setDetail((val) => ({ ...val, ...res }));
      isEdit.current = true;
    });
  };
  // 清空
  const clearInput = () => {
    let needList = [
      "platenumber",
      "vin",
      "enginenumber",
      "caramount",
      "taxamount",
      "mortgageserviceamount",
    ];
    if (params.source === "emo") {
      needList = [...needList, "brandname", "vehiclename"];
    }
    const obj: any = {};
    needList.map((item) => (obj[item] = ""));
    setDetail((val) => ({ ...val, ...obj }));
    isEdit.current = false;
  };
  // 下发
  const confirmTo = () => {
    if (
      !Object.keys(defaultDetail).every(
        (item) => detail[item] === 0 || detail[item]
      )
    ) {
      Toast.show("请填写完整表单计算后再试！");
      return;
    }
    if (!isEdit.current) {
      Toast.show("未计算结果，请计算后再试！");
      return;
    }
    if (detail.id) {
      CommonService.confirmEdit({ ...detail, source: params.source }).then(
        () => {
          replaceTo("/customer-into", { key: "2" });
        }
      );
      return;
    }
    CommonService.confirmCreate({ ...detail, source: params.source }).then(
      () => {
        replaceTo("/customer-into", { key: "2" });
      }
    );
  };
  let stages: Array<Array<{ label: string; value: string }>> = [[]];
  if (params.source === "ktm" && cfKcc) {
    stages = [[{ label: "18期", value: "18" }]];
  } else if (params.source === "zeeho") {
    stages = [
      [
        { label: "6期", value: "6" },
        { label: "12期", value: "12" },
        { label: "18期", value: "18" },
      ],
    ];
  } else if (params.source == "cfmoto" && cfKcc) {
    stages = [[{ label: "12期", value: "12" }]];
  } else {
    stages = [
      [
        ...(params.source === "zsmoto" && cfKcc
          ? []
          : [
              { label: "6期", value: "6" },
              { label: "9期", value: "9" },
            ]),
        { label: "12期", value: "12" },
        { label: "18期", value: "18" },
        { label: "24期", value: "24" },
      ],
    ];
    // if (detail.caramount>=30000){
    // 	stages[0].push({label: '36期',value: '36'})
    // }
  }
  const firstpaidpercentList: Array<Array<{ label: string; value: string }>> = [
    [],
  ];
  const ratio = [0, 0.05, 0.1, 0.15, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9];
  // if (params.source === "cfmoto" && !cfKcc) {
  //   ratio.shift();
  // }
  for (const it of ratio) {
    // it >= (parseFloat(params.firstpaidpercent) || 0) &&
      firstpaidpercentList[0].push({
        label: (it * 100).toFixed(0) + "%",
        value: String(it),
      });
  }
  // console.log(firstpaidpercentList);
  return (
    <div>
      <INavBar title={`${params.userName}的金融方案`} />
      <div className="plan-page">
        {detail.rejectReason && (
          <div className="reson">
            {params.status === "1" && "驳回"}
            {params.status === "3" && "拒绝"}
            {params.status === "6" && "终止"}
            {params.status === "7" && "结束"}
            原因:
            <div>{detail.rejectReason}</div>
          </div>
        )}

        <VerticalSpace size={20}>
          <div className="part-box">
            <div className="box-header">车辆信息</div>
            <VerticalSpace size={16}>
              <FormItemBox
                required
                left="品牌："
                right={
                  params.source === "cfmoto" ? (
                    "春风"
                  ) : params.source === "zsmoto" ? (
                    "赛科龙"
                  ) : params.source === "ktm" ? (
                    "KTM"
                  ) : params.source === "zeeho" ? (
                    "ZeehoApp"
                  ) : (
                    <input
                      type="text"
                      value={detail.brandname || ""}
                      onChange={(e) =>
                        changeDetail({ brandname: e.target.value })
                      }
                    />
                  )
                }
              />
              <FormItemBox
                required
                left="车型："
                right={<span style={{ flex: 1 }}>{detail.vehiclename}</span>}
              />
              <FormItemBox
                required
                left={"车辆价格(元)："}
                right={
                  <input
                    type="text"
                    maxLength={10}
                    value={detail.caramount}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^\d]/, "");
                      changeDetail({ caramount: value });
                    }}
                  />
                }
              />
            </VerticalSpace>
          </div>
          <div className="part-box">
            <div className="box-header">金融方案选择</div>
            <VerticalSpace size={16}>
              <Flex className="box-flex" justify="between">
                <span>费率（%）：</span>
                <span>{`${(detail.rate * 100).toFixed(2)}%`}</span>
              </Flex>
              <Flex className="box-flex" justify="between">
                <span>履约保证金比例（%）：</span>
                <span>{`${(detail.earnestmoneypercent * 100).toFixed(
                  2
                )}%`}</span>
              </Flex>
              <FormItemBox
                required
                left={"首付比例："}
                rightClick={() => {
                  setFirstpaidpercentVisible(true);
                }}
                right={
                  <>
                    <span style={{ flex: 1 }}>
                      {((detail.firstpaidpercent || 0) * 100).toFixed(0)}%
                    </span>
                    <DownFill />
                  </>
                }
              />
              <FormItemBox
                required
                left={"租赁期数："}
                rightClick={() => {
                  setStageVisible(true);
                }}
                right={
                  <>
                    <span style={{ flex: 1 }}>{detail.stage}期</span>
                    <DownFill />
                  </>
                }
              />
              {params.source === "cfmoto" && cfKcc && (
                <FormItemBox
                  required
                  left="抵押代办费："
                  right={
                    <input
                      type="text"
                      maxLength={10}
                      value={detail.mortgageserviceamount}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d]/, "");
                        changeDetail({ mortgageserviceamount: value });
                      }}
                    />
                  }
                />
              )}
              <FormItemBox
                required
                left="手续费率（%）"
                right={
                  <span style={{ flex: 1 }}>{`${
                    !isEmpty(detail.commissionrate)
                      ? (detail.commissionrate * 100).toFixed(0)
                      : ""
                  }%`}</span>
                }
              />
              {/* <Flex className="box-flex required" justify="between">
								<span>是否分期购置税：</span>
								{
									(!ifcontainsecurityservice) 
										? <ItemCheckOnlyFalse
											value={detail.containtax}
											valueChange={(val: any) => changeDetail({ containtax: val })}
										/>
										: <ItemCheck
											value={detail.containtax}
											valueChange={(val: any) => changeDetail({ containtax: val })}
										/>
								}
							</Flex> */}
              {detail.containtax > 0 && (
                <FormItemBox
                  required
                  left="购置税金额(元)"
                  right={<span style={{ flex: 1 }}>{detail.taxamount}</span>}
                />
              )}

              {(params.source === "emo" || params.source === "zsmoto") && <Flex className="box-flex required" justify="between">
                <span>是否分期盗抢权益：</span>
                <ItemCheck
                  value={detail.containsecurityservice}
                  valueChange={(val: any) =>
                    changeDetail({ containsecurityservice: val })
                  }
                />
              </Flex>}
              {/* {params.source === "emo" && (
                <Flex className="box-flex required" justify="between">
                  <span>是否超融盗抢保障服务：</span>
                  {params.source === "emo" ? (
                    <ItemCheck
                      value={detail.containsecurityservice}
                      valueChange={(val: any) =>
                        changeDetail({ containsecurityservice: val })
                      }
                    />
                  ) : (
                    <ItemCheckOnlyFalse
                      value={detail.containsecurityservice}
                      valueChange={(val: any) =>
                        changeDetail({ containsecurityservice: val })
                      }
                    />
                  )}
                </Flex>
              )} */}
              <Space
                style={{ "--gap": "80px", width: "100%" }}
                justify="center"
              >
                <Button
                  style={{
                    "--background-color": "#4B4F60",
                    "--border-width": "0",
                    "--text-color": "#fff",
                  }}
                  onClick={clearInput}
                >
                  清空
                </Button>
                <Button
                  style={{
                    "--background-color": "#6291DF",
                    "--border-width": "0",
                    "--text-color": "#fff",
                  }}
                  onClick={caleResult}
                >
                  确认
                </Button>
              </Space>
            </VerticalSpace>
          </div>
          <div className="part-box">
            <div className="box-header">方案展示（具体以还款计划表为准。）</div>
            <VerticalSpace size={16}>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">融租总额（元）：</span>
                <span className="plan-text">{detail.finalamount}</span>
              </Space>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">首付款（元）：</span>
                <span className="plan-text">{detail.firstpaidamount}</span>
              </Space>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">月还款（元）：</span>
                <span className="plan-text">{detail.everypayamount}</span>
              </Space>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">骑行意外险费用（元）:</span>
                <span className="plan-text">
                  {detail.rideaccidentserviceamount}
                </span>
              </Space>
              {detail.mortgageserviceamount > 0 && (
                <Space style={{ "--gap": "6px" }}>
                  <span className="plan-label">抵押代办费:</span>
                  <span className="plan-text">
                    {detail.mortgageserviceamount}
                  </span>
                </Space>
              )}
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">盗抢保障费用（元）：</span>
                <span className="plan-text">
                  {detail.securityserviceamount}
                </span>
              </Space>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">手续费（元）：</span>
                <span className="plan-text">{detail.commission}</span>
              </Space>
              <Space style={{ "--gap": "6px" }}>
                <span className="plan-label">
                  履约保证金（元）(结清可退还)：
                </span>
                <span className="plan-text">{detail.performanceBond}</span>
              </Space>
              {!isEmpty(detail.freeStage) && (
                <Space style={{ "--gap": "6px" }}>
                  <span className="plan-label">减免费用期数 ：</span>
                  <span className="plan-text">{detail.freeStage}</span>
                </Space>
              )}
              {!isEmpty(detail.freeCount) && (
                <Space style={{ "--gap": "6px" }}>
                  <span className="plan-label">减免费用合计（元）：</span>
                  <span className="plan-text">{detail.freeCount}</span>
                </Space>
              )}
              {!isEmpty(detail.rentCount) && (
                <Space style={{ "--gap": "6px" }}>
                  <span className="plan-label">减免后租金合计（元）：</span>
                  <span className="plan-text">{detail.rentCount}</span>
                </Space>
              )}
            </VerticalSpace>
          </div>
        </VerticalSpace>
        <div className="footer-btn" onClick={confirmTo}>
          确定并下发用户确认
        </div>
      </div>
      <Picker
        title="期数选择"
        visible={stageVisible}
        onConfirm={stageSelect}
        onClose={() => {
          setStageVisible(false);
        }}
        columns={stages}
      />
      <Picker
        title="首付比例"
        visible={firstpaidpercentVisible}
        defaultValue={[ratio.indexOf(Number(params.firstpaidpercent))]}
        onConfirm={(e) => {
          changeDetail({ firstpaidpercent: e[0] });
        }}
        onClose={() => {
          setFirstpaidpercentVisible(false);
        }}
        columns={firstpaidpercentList}
      />
    </div>
  );
}

// 栏目
function FormItemBox(props: any) {
  const { required } = props;
  const classNames = ["item-box"];
  required && classNames.push("required");
  return (
    <div className={classNames.join(" ")}>
      <div>{props.left}</div>
      <div onClick={() => props.rightClick?.()}>{props.right}</div>
    </div>
  );
}

// 禁止选择框
function ItemCheck(props: any) {
  const [value, setValue] = useState(props.value || 0);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <Radio.Group
      value={value}
      onChange={(val: any) => {
        setValue(val);
        props.valueChange?.(parseInt(val));
      }}
    >
      <Space style={{ "--gap": "50px" }}>
        <Radio value={1}>是</Radio>
        <Radio value={0}>否</Radio>
      </Space>
    </Radio.Group>
  );
}

// 选择框
function ItemCheckOnlyFalse(props: any) {
  const [value, setValue] = useState(props.value || 0);

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value);
    }
  }, [props.value]);

  return (
    <Radio.Group defaultValue={0} disabled value={value}>
      <Space style={{ "--gap": "50px" }}>
        <Radio value={1} className={value === 1 ? "" : "no-icon"}>
          是
        </Radio>
        <Radio value={0} className={value === 0 ? "" : "no-icon"}>
          否
        </Radio>
      </Space>
    </Radio.Group>
  );
}

export default PlanDetailEdit;
